import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class ExchangeMailConfigTestResult<T extends EMode = EMode.entity> {
  /** Alias: errorMessage */
  errorMessage?: string;
  /** Alias: connectionOk */
  connectionOk?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<ExchangeMailConfigTestResult> = {
  errorMessage: {
    alias: 'errorMessage',
  },
  connectionOk: {
    alias: 'connectionOk',
  },
  __typename: {
    alias: '__typename',
  },
};

export const exchangeMailConfigTestResultEntityDefinition: EntitiyDefinition<ExchangeMailConfigTestResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ExchangeMailConfigTestResult',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'testGeneralEwsSettings',
          args: [],
        },
      },
    },
    fieldDefinitions: fields,
  };
